import type { Fallacy } from "./types";
import { createStory } from "./types";

export const falseDilemma: Fallacy = {
    id: "false-dilemma",
    name: "False Dilemma",
    emoji: "⚖️",
    category: "Logika Rusak",
    description:
      "Menyajikan **hanya dua pilihan** seolah tidak ada opsi lain, padahal **ada banyak kemungkinan**.",
    detail:
      "False Dilemma adalah kesalahan logika di mana seseorang menyajikan situasi seolah **hanya ada dua pilihan** (hitam atau putih), padahal kenyataannya **ada banyak opsi** di antaranya. Disebut juga 'Either-Or Fallacy' atau 'Black-and-White Thinking'.\n\nKenapa ini berbahaya? Karena **memaksa orang berpikir sempit** dan menghilangkan ruang untuk nuansa, kompromi, atau solusi kreatif. Dunia nyata jarang sesederhana A atau B.\n\nCara melawan: Tunjukkan bahwa ada pilihan ketiga, keempat, atau kelima. \"Bukan cuma itu pilihannya. Bagaimana kalau...\"",
    tldr: "Pilihan cuma A atau B? Emang gak ada opsi C, D, E? False Dilemma tuh.",
    story: createStory("False Dilemma", "⚖️", {
      hook: {
        title: "\"Pilih A atau B. Titik!\"",
        body: "Emang gak ada opsi C, D, E? Kenapa kamu dipaksa milih **cuma dua**?",
      },
      convo: {
        claim: "Mau kuliah atau mau jadi gelandangan? **Cuma dua itu pilihannya.** Pilih sekarang!",
        response: "Gap year, kursus, magang — **banyak opsi lain** selain dua pilihan ekstrem itu.",
      },
      reveal: {
        body: "Menyajikan situasi seolah **cuma ada dua pilihan** — hitam atau putih. Padahal kenyataannya **banyak opsi** di antaranya.",
      },
      insight: {
        title: "Kenapa ini bahaya?",
        body: "Dunia nyata jarang sesederhana A atau B. Kalau kamu dipaksa milih dua, kemungkinan besar **ada opsi lain yang sengaja disembunyiin**.",
      },
      engagement: {
        title: "Pernah dipaksa pilih A atau B padahal ada opsi C?",
        body: "Di keluarga, kantor, atau debat politik? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["straw-man", "slippery-slope", "circular-reasoning"],
  };
